import axios from 'axios'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../../config/api'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import { OrderOrigin, OrderOriginInfoDto } from '../../../interfaces/OrderOrigin/OrderOrigin'

export const getOrderOriginList = (
  filters: Filter[],
  page: number,
  pageSize: number,
  orderBy?: GenericOrderBy<OrderOriginInfoDto>
) => {
  const url = new URL(`${ApiConfig.OrderOriginApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const getOrderOriginById = (id: number) => {
  return axios.get(`${ApiConfig.OrderOriginApi}/${id}`)
}

export const createOrderOrigin = (orderOrigin: OrderOrigin) => {
  return axios.post(`${ApiConfig.OrderOriginApi}`, orderOrigin)
}

export const updateOrderOrigin = (id: number, orderOrigin: OrderOrigin) => {
  return axios.put(`${ApiConfig.OrderOriginApi}/${id}`, orderOrigin)
}

export const deleteOrderOrigin = (id: number) => {
  return axios.delete(`${ApiConfig.OrderOriginApi}/${id}`)
}
